// extracted by mini-css-extract-plugin
export default {"app-wrapper":"BHs4fV","app-wrapper__button":"dlcvd_","app-wrapper__description":"BmtBDr"};